import { handleValidationChange } from "../CommonValidation";

export const validateTransaction = (data, setIsError) => {
    var isValid = true;

    // Validate transaction date
    if (!data.transaction_date || data.transaction_date === "") {
        handleValidationChange("transaction_date", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("transaction_date", false, setIsError);
    }

    // Validate reference number
    if (!data.reference_no || data.reference_no.trim() === "") {
        handleValidationChange("reference_no", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("reference_no", false, setIsError);
    }

    // Validate bank from
    if (!data.bank_from_id || data.bank_from_id === "" || data.bank_from_id === "0") {
        handleValidationChange("bank_from_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("bank_from_id", false, setIsError);
    }

    // Validate bank to
    if (!data.bank_to_id || data.bank_to_id === "" || data.bank_to_id === "0") {
        handleValidationChange("bank_to_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("bank_to_id", false, setIsError);
    }

    // Validate that bank_from and bank_to are different
    if (data.bank_from_id && data.bank_to_id && data.bank_from_id === data.bank_to_id) {
        handleValidationChange("bank_to_id", "Cannot transfer to the same bank", setIsError);
        isValid = false;
    }

    // Validate amount
    if (!data.amount || data.amount === "" || parseFloat(data.amount) <= 0) {
        handleValidationChange("amount", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("amount", false, setIsError);
    }

    // Validate remarks (optional but if provided should not be empty)
    if (data.remarks && data.remarks.trim() === "") {
        handleValidationChange("remarks", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("remarks", false, setIsError);
    }

    return isValid;
};

export const validateTransactionCreate = (data, setIsError) => {
    var isValid = true;

    // Validate transaction date
    if (!data.transaction_date || data.transaction_date === "") {
        handleValidationChange("transaction_date", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("transaction_date", false, setIsError);
    }

    // Validate reference number
    if (!data.reference_no || data.reference_no.trim() === "") {
        handleValidationChange("reference_no", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("reference_no", false, setIsError);
    }

    // Validate bank from
    if (!data.bank_from_id || data.bank_from_id === "" || data.bank_from_id === "0") {
        handleValidationChange("bank_from_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("bank_from_id", false, setIsError);
    }

    // Validate bank to
    if (!data.bank_to_id || data.bank_to_id === "" || data.bank_to_id === "0") {
        handleValidationChange("bank_to_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("bank_to_id", false, setIsError);
    }

    // Validate that bank_from and bank_to are different
    if (data.bank_from_id && data.bank_to_id && data.bank_from_id === data.bank_to_id) {
        handleValidationChange("bank_to_id", "Cannot transfer to the same bank", setIsError);
        isValid = false;
    }

    // Validate amount
    if (!data.amount || data.amount === "" || parseFloat(data.amount) <= 0) {
        handleValidationChange("amount", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("amount", false, setIsError);
    }

    // Validate remarks (optional but if provided should not be empty)
    if (data.remarks && data.remarks.trim() === "") {
        handleValidationChange("remarks", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("remarks", false, setIsError);
    }

    return isValid;
};

export const validateTransactionUpdate = (data, setIsError) => {
    return validateTransaction(data, setIsError);
};


